<template>
  <div class="hello">
    <hd class="header"></hd>
    1111
    <!--<ul class="clearfix crumbs gray-txt">
      <li>123<span>/</span></li>
    </ul>-->
    <div class="main-content">
      <router-view/>
    </div>
    <mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>
    <GlobalDialogs></GlobalDialogs>
  </div>
</template>

<script>
import hd from './Header'
import ft from './Footer'
import GlobalDialogs from './GlobalDialogs'
import mobilefooter from './mobilefooter'

export default {
  name: 'HelloWorld',
  components: {
    hd: hd,
    ft: ft,
    mobilefooter: mobilefooter,
    GlobalDialogs: GlobalDialogs,
  },
  created() {
    if (document.body.clientWidth < 1024) {
      this.mobiletype = true
    }
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      mobiletype: false,
      screenWidth: document.body.clientWidth,
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  watch: {
        screenWidth (val) {
          if (!this.timer) {
            this.screenWidth = val
            console.log(val)
            if (val < 1024) {
              this.mobiletype = true
            }
            else {
              this.mobiletype = false
            }
            this.timer = true
            let that = this
            setTimeout(function () {
              // that.screenWidth = tha t.$store.state.canvasWidth
              that.timer = false
            }, 400)
          }
        },
    }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .header {
    border-bottom: 1px solid #d7d7d7;
  }
  .crumbs {
    margin-top: 34px;
    max-width: 1200px;
    margin: 34px auto 10px;
  }
  .main-content {
    padding-top: 70 + 116px;
    .select-shop {
      max-width: 760px;
      margin: 0 auto;
    }
    .publish-task-product {
      max-width: 1140px;
      margin: 0 auto;
    }
  }

  @media screen and (max-width:1024px){
    .main-content {
      padding-top: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue